/** Effective-dated statutory floors for Irish security operatives. */

export const IRISH_SECURITY_ERO_COUNTRY_CODE = 'IE';
export const IRISH_SECURITY_ERO_UNSOCIAL_START_MINUTE = 21 * 60;
export const IRISH_SECURITY_ERO_UNSOCIAL_END_MINUTE = (24 + 7) * 60;
export const IRISH_SECURITY_ERO_UNSOCIAL_MIN_MINUTES = 3 * 60;
export const IRISH_SECURITY_ERO_MINIMUM_SHIFT_MINUTES = 4 * 60;
export const IRISH_SECURITY_ERO_ROSTER_NOTICE_HOURS = 72;
export const IRISH_SECURITY_ERO_MINIMUM_CONTRACT_HOURS = 24;

interface EffectiveRate {
  effectiveFrom: string;
  amount: number;
}

const HOURLY_RATES: EffectiveRate[] = [
  { effectiveFrom: '2025-07-22', amount: 15.41 },
  { effectiveFrom: '2026-09-28', amount: 16.15 },
];

const UNSOCIAL_PREMIUMS: EffectiveRate[] = [
  { effectiveFrom: '2024-07-01', amount: 12.60 },
  { effectiveFrom: '2025-01-01', amount: 16.80 },
  { effectiveFrom: '2026-01-01', amount: 20 },
];

function rateForDate(schedule: EffectiveRate[], dateKey: string): number | null {
  let result: number | null = null;
  schedule.forEach((rate) => {
    if (rate.effectiveFrom <= dateKey) result = rate.amount;
  });
  return result;
}

export function isIrishCountryCode(countryCode: string | null | undefined): boolean {
  return countryCode?.trim().toUpperCase() === IRISH_SECURITY_ERO_COUNTRY_CODE;
}

export function securityEroMinimumHourlyRate(dateKey: string): number | null {
  return rateForDate(HOURLY_RATES, dateKey);
}

export function securityEroUnsocialPremium(dateKey: string): number | null {
  return rateForDate(UNSOCIAL_PREMIUMS, dateKey);
}

export interface EffectiveRateChange {
  effectiveFrom: string;
  amount: number;
  previousAmount: number;
}

/** The latest step in the hourly rate on or before a date, with the rate it replaced. */
export function securityEroLatestHourlyRateChange(dateKey: string): EffectiveRateChange | null {
  let change: EffectiveRateChange | null = null;
  HOURLY_RATES.forEach((rate, index) => {
    if (index > 0 && rate.effectiveFrom <= dateKey) {
      change = {
        effectiveFrom: rate.effectiveFrom,
        amount: rate.amount,
        previousAmount: HOURLY_RATES[index - 1].amount,
      };
    }
  });
  return change;
}

export function securityEroCurrentMinimumHourlyRate(dateKey: string): number {
  return securityEroMinimumHourlyRate(dateKey) ?? 15.41;
}

